import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import authSlice from "../features/auth/authSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authSlice,
  },
  middleware: (getDefaultMiddlewars) =>
    getDefaultMiddlewars().concat(apiSlice.middleware),

  devTools: process.env.NODE_ENV !== "production",
});
